import { Button, Card, Flex } from '@servicetitan/anvil2';
import { ApplicationDataStore } from '@servicetitan/financing-application-shared';
import { StatusContainer, DataItem } from '@servicetitan/financing-utils-shared';
import ApprovedIllustration from '../../common/illustrations/checkmark-success.svg';

export interface AcceptedOfferProps {
    cameFromLoanTaskView?: boolean;
    onViewOfferDetails?: () => void;
}

export const AcceptedOffer = ({
    cameFromLoanTaskView = false,
    onViewOfferDetails,
}: AcceptedOfferProps) => {
    const { applicationData } = ApplicationDataStore.useStore();

    const email = applicationData?.applicant?.primaryApplicant?.email ?? '';
    const phone = applicationData?.applicant?.primaryApplicant?.primaryPhone ?? '';

    const hasContactInfo = [email, phone].some(contact => contact.length > 0);

    const message = hasContactInfo
        ? 'Loan agreement documents and instructions to activate the loan have been emailed and texted to the following:'
        : 'Loan agreement documents and instructions to activate the loan have been sent to the email address provided during application.';

    return (
        <StatusContainer
            headline="You accepted the offer!"
            message={message}
            image={ApprovedIllustration}
        >
            {hasContactInfo && (
                <Card flexDirection="column" style={{ maxWidth: '845px', width: '100%' }}>
                    <Flex gap="3" direction="column">
                        <DataItem label="Email" text={email} />
                        <DataItem label="Phone Number" text={phone} />
                    </Flex>
                </Card>
            )}
            {cameFromLoanTaskView && onViewOfferDetails && (
                <Flex direction="column" style={{ width: '100%', marginTop: '1rem' }}>
                    <Button
                        appearance="primary"
                        onClick={onViewOfferDetails}
                        style={{ width: '100%' }}
                    >
                        View Offer Details
                    </Button>
                </Flex>
            )}
        </StatusContainer>
    );
};
